"use strict";
exports.__esModule = true;
exports.r = void 0;
var client_1 = require("./httr/client");
exports.r = {
    info: {
        key: 'r',
        title: 'R',
        extname: '.r',
        "default": 'httr'
    },
    clientsById: {
        httr: client_1.httr
    }
};
//# sourceMappingURL=target.js.map